import { TestMethodGroupItem } from "./test-method-group-item.model";

export class TestMethodGroup {
  id: number;
  name: string;
  companyId?: number;
  testMethodGroupItems: TestMethodGroupItem[];
}
